import { observable, computed, action, runInAction, makeObservable } from "mobx";
import { VehicleMetaDataModel as VehicleMetaData } from './ServiceVehicleModel';
import ServiceIntervalsModel from "./ServiceIntervalsModel";
import OperationDetailsModel from "./OperationDetailsModel";
import { ApiBasePath } from "../../../utils/ApiBasePath";
import * as Request from "superagent";

export default class ServiceDetailsModel {
    @observable response: VehicleMetaData;
    @observable isRegoDetailsExist: boolean = false;
    @observable isRegoRequestError: boolean = false;
    @observable isRegoFetching: boolean = false;
    @observable isVinDetailsExist: boolean = false;
    @observable isVinRequestError: boolean = false;
    @observable isVinFetching: boolean = false;
    serviceIntervals: ServiceIntervalsModel;
    resetDetails: () => void;

    constructor(serviceIntervals, resetDetails) {
      makeObservable(this);
      this.serviceIntervals = serviceIntervals;
      this.resetDetails = resetDetails;
    }
  
    @computed get rego(): string {
      return this.response ? this.response.registrationNumber : '';
    }
  
    @computed get vin(): string {
      return this.response ? this.response.vin : '';
    }
  
    @computed get model(): string {
      return this.response ? this.response.model.description : '';
    }
  
    @action reset = () => {
      this.response = null;
      this.isRegoDetailsExist = false;
      this.isRegoRequestError = false;
      this.isRegoFetching = false;
      this.isVinDetailsExist = false;
      this.isVinRequestError = false;
      this.isVinFetching = false;
    }

    @action fetchVehicleDetailsByRego = (regoNumber: string) => {
      this.isRegoFetching = true;
      let url = `${ApiBasePath.infomedia}/vehicle/find-by-registration/${regoNumber}`;
      Request.get(url).then(
        response => {
          runInAction(() => {
            this.response = response.body;
            this.isRegoFetching = false;
            this.isRegoDetailsExist = true;
            this.isRegoRequestError = false;
            this.serviceIntervals.fetchServiceIntervalsByVin(this.vin);
          });
        },
        error => {
          runInAction(() => {
            console.log(`An error occurred loading your vehicle details by rego: ${error}`);
            this.resetDetails();
            this.isRegoRequestError = true;
          });
        }
      );
    };
  
    @action fetchVehicleDetailsByVin = (vinNumber: string) => {
      this.isVinFetching = true;
      let url = `${ApiBasePath.infomedia}/vehicle/find-by-vin/${vinNumber}`;
      Request.get(url).then(
        response => {
          runInAction(() => {
            this.response = response.body;
            this.isVinFetching = false;
            this.isVinDetailsExist = true;
            this.isVinRequestError = false;
            this.serviceIntervals.fetchServiceIntervalsByVin(this.vin);
          });
        },
        error => {
          runInAction(() => {
            console.log(`An error occurred loading your vehicle details by vin: ${error}`);
            this.resetDetails();
            this.isVinRequestError = true;
          });
        }
      );
    };
  }